(function (angular) {
  "use strict";

  angular.module('myApp').component("textboxDate", {
    templateUrl: '/core/components/textboxDate/textboxDate.tpl.html',
    transclude: true,
    bindings: {
      name: '@',
      label: '@?',
      placeholder: '@',
      type: '@',
      maxlength: '@',
      service: '=',
      required: '@',
      changed: '&',
      disabledIf: '<?',
    },
    controller: ['$scope',
      function ($scope) {

        this.$onInit = function () {
          
          setTimeout(function () {
            if ($scope.$ctrl.service.dto[$scope.$ctrl.name] != undefined && $scope.$ctrl.service.dto[$scope.$ctrl.name] != null) {
              var d = new Date($scope.$ctrl.service.dto[$scope.$ctrl.name]);
              var datestring = ("0" + (d.getMonth() + 1)).slice(-2) + "/" + ("0" + d.getDate()).slice(-2) + "/" + d.getFullYear();
              $scope.$ctrl.service.dto[$scope.$ctrl.name] = datestring;
              $scope.$apply();
            }
          
            $('.datepicker').datepicker({
              todayBtn: "linked",
              clearBtn: true,
              autoclose: true,
              todayHighlight: true,
              format: 'mm/dd/yyyy'            
            });           
          },400);        
        };
      }
    ]
  });

}(window.angular));
